<template>
  <div class="">
    <div class="body">
      <h2 class="card-inside-title">그룹 라벨 (선택)</h2>
      <div class="row clearfix">
        <div class="col-sm-12">
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              v-model="groupList.label"
              placeholder="그룹 라벨 등록"
              @keyup="insertGroupData"
            />
          </div>
        </div>
      </div>

      <h2 class="card-inside-title">그룹 키 (필수)</h2>
      <div class="row clearfix">
        <div class="col-sm-12">
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              v-model="groupList.key"
              placeholder="그룹 키 등록"
              @keyup="insertGroupData"
            />
          </div>
        </div>
      </div>

      <h2 class="card-inside-title">라인 아이템</h2>
      <div class="row clearfix">
        <div class="col-sm-12">
          <div class="body">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>라벨</th>
                    <th>키</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(list, index) in lineList" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ list.key }}</td>
                    <td>{{ list.label }}</td>
                    <td>
                      <a href="javascript:void(0);" @click="editItem(index)"
                        >수정</a
                      >
                      &nbsp;&nbsp;
                      <a href="javascript:void(0);" @click="removeItem(index)"
                        >삭제</a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <button
                type="button"
                class="btn btn-default"
                @click="toActionAddLineItem"
              >
                아이템 추가
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="text-align: right; margin-bottom: 10px">
      <button
        type="button"
        class="btn btn-primary"
        @click="submitActionLineGroup"
      >
        저장
      </button>
      <button type="button" class="btn btn-default" @click="toActionInput">
        취소
      </button>
    </div>
  </div>

  <!-- #END# Input -->
</template>

<script>
import eventbus from "@/store/modules/devEventBus";

export default {
  props: ["typeData"],
  methods: {
    changeActionType(num) {
      if (num == 1) {
        this.forSearch = true;
      } else {
        this.forSearch = false;
      }
    },
    toActionInput() {
      this.$router.push({
        name: "DevActInput",
        params: { appId: this.$route.params.appId },
      });
    },
    toActionAddLineItem() {
      //  if(this.lineList != null){
      //      console.log("길이2", this.lineList.length)
      //      this.listCount == this.lineList.lenght
      //  }
      console.log("길이:", this.lineList, this.listCount);

      this.$store.state.devStore.lineGroup.groupKey = 
      this.$store.state.devStore.lineGroup.groupLabel

      this.$store.state.devStore.lineIndex = this.lineList.length
      

      eventbus.$emit("KeyValueComponent")

      // this.$router.push({
      //   name: "DevActInputLineKeyVal",
      //   params: {
      //     appId: this.$route.params.appId,
      //     typeOfThisBtn: "__new__",
      //     itemIndex: this.listCount,
      //   },
      // });
    },
    insertGroupData() {
      console.log(this.groupKey);

      var map = new Map();
      map.set("key", this.groupKey);
      map.set("label", this.groupLabel);

      eventbus.$emit("grouplist", map);
    },
    removeItem(index) {
      if(confirm("삭제하시겠습니까?")){
        var tem = new Array();
        for (var i = 0; i < this.$store.state.devStore.lineItem.length; i++) {
          if (i != index) {
            tem.push(this.$store.state.devStore.lineItem[i]);
            //             // this.$store.state.devStore.lineItem[i].label = res.label
          }
        }
        this.lineList = tem;
        this.$store.state.devStore.lineItem = this.lineList;

        this.listCount = this.lineList.length;

        console.log(index);
        console.log(tem);
        console.log(
          "변경된 값은 이렇다~~",
          this.lineList,
          this.$store.state.devStore.lineItem
        );

      }
    },
    editItem(index) {

      this.$store.state.devStore.lineIndex = index
      eventbus.$emit("KeyValueComponent")
      // console.log(this.$store.state.devStore.formsData)
      // console.log(this.$store.state.devStore.formsData[index])
      // console.log(this.$store.state.devStore.apiSchema.form)
      // console.log(JSON.parse(this.$store.state.devStore.apiSchema.form)[index])

      // this.$store.state.devStore.lineItem = JSON.parse(this.$store.state.devStore.apiSchema.form)

      // this.$router.push({
      //   name: "DevActInputLineKeyVal",
      //   params: {
      //     appId: this.$route.params.appId,
      //     itemIndex: index,
      //     typeOfThisBtn: "__old__",
      //     listCount: this.listCount,
      //   },
      // });
    },
    submitActionLineGroup() {
      if (this.groupKey != null) {
        this.groupKey = this.groupKey.replace(/\s/g, "");
      }

      if (this.groupKey == null || this.groupKey == "") {
        alert("그룹키는 필수 입력 항목 입니다.");
        return;
      }

      // console.log(this.$store.state.devStore.reMenu);
      // var indexNum = this.$store.state.devStore.reMenu;

      // this.$store.dispatch("addRequestBodyWhileAdding", {
      //     keys : this.groupKey,
      //     oldText : this.oldText
      // }).then(()=>{

      var map = new Map();

      if (this.oldText == null) {
        if (
          this.groupKey != null &&
          this.groupKey != "null" &&
          this.groupKey != ""
        ) {
          map.set(this.groupKey, "{{bundle.inputData." + this.groupKey + "}}");
        }
      } else {
        if (
          this.groupKey != null &&
          this.groupKey != "null" &&
          this.groupKey != ""
        ) {
          map.set("oldText", this.oldText);
          map.set(this.groupKey, "{{bundle.inputData." + this.groupKey + "}}");
        }
      }

      var param = {
        appCode: this.$store.state.devStore.appCode,
        apiCode: this.$store.state.devStore.apiCode,

        checkType: "lineGroup",
        where: "input",

        index: this.indexer,
        keys: this.$store.state.devStore.lineGroup.keys.replace(/"/gi, ""),
        label: this.$store.state.devStore.lineGroup.label.replace(/"/gi, ""),
        // types: this.type,
        // field: this.field,
        form: JSON.stringify(this.$store.state.devStore.lineItem),
        // formArray: this.lineList,
        // format: this.format,

        apiSchema: JSON.stringify(Object.fromEntries(map)),

        // apiSchema : JSON.stringify(this.$store.state.devStore.formsData)
      };

      this.api.configSchema(param)
        .then((res) => {
          console.log("저장 : ", res);

          //  eventbus.$emit('menuReset')
          this.api.selectApiSchema({apiCode : this.$store.state.devStore.apiCode})
              .then((res)=>{

                this.$store.dispatch("apiDetail", {result : res}).then(() => {
                  //이부분 오류
                  this.$router.push({
                    name: "DevActInput",
                    params: { appId: this.$route.params.appId },
                  });
                });

              })
        })
        .catch(() => alert("오류가 발생했습니다. line Group Item"));

      // })
      // .catch(()=> alert("오류가 발생했습니다. line group json "))

      //필드 추가시 requestBody 에 추가하는 부분

      // var reqBody = this.$store.state.devStore.configureData[0].requestBody

      //     console.log("와 ??????아 ?????", Object.keys(JSON.parse(this.$store.state.devStore.configureData[0].requestBody)))
      // //     // console.log("와 ??????아 ?????", typeof(JSON.parse(this.$store.state.devStore.configureData[0].requestBody )))

      // var inin2 = new Array()
      // if(Object.keys(JSON.parse(reqBody)).length > 0){
      //     for(var k = 0; k < Object.keys(JSON.parse(reqBody)).length; k++){

      //         var keyName = Object.keys(JSON.parse(reqBody))[k]

      //         var data = new Object()

      //         if(this.oldText != null && this.oldText == keyName){
      //                 data.keys = this.groupKey

      //                 if(Object.values(JSON.parse(reqBody))[k].includes("{{")){
      //                     data.values = "{{bundle.inputData." + this.groupKey + "}}"
      //                 } else {
      //                     data.values = Object.values(JSON.parse(reqBody))[k]

      //                 }

      //             } else {

      //                 data.keys = Object.keys(JSON.parse(reqBody))[k]
      //                 data.values = Object.values(JSON.parse(reqBody))[k]

      //             }

      //         inin2.push(data)
      //     }

      // } else {
      //     data = new Object()
      //     data.keys = this.groupKey
      //     data.values = "{{bundle.inputData." + this.groupKey + "}}"

      //     inin2.push(data)

      // }

      // console.log("와 ??????아 ?????", inin2 )

      // var map = new Map()

      // for(var i = 0; i < inin2.length; i++){
      //     if(inin2[i].keys != null && inin2[i].keys != "null" && inin2[i].keys != ""){
      //         map.set(inin2[i].keys, inin2[i].values)

      //     }

      // }

      // if(this.oldText == null){
      //     if(this.groupKey != null && this.groupKey != "null" && this.groupKey != ""){
      //         map.set(this.groupKey, "{{bundle.inputData." + this.groupKey + "}}")

      //     }

      // }

      // console.log("와 ??????아 ?????", map )

      // this.$store.state.devStore.configureData[0].requestBody = Object.fromEntries(map)
    },
  },

  data() {
    return {
      types: "",
      forSearch: false,
      index: 0,
      lineList: [],

      listCount: 0,

      groupLabel: "",
      groupKey: "",
      oldText: null,

      groupList: { key: "", label: "" },

      // indexer: 0,
    };
  },
  mounted() {
    // console.log("mounted :",this.$store.state.devStore.lineItem)
    // console.log("mounted :",this.$store.state.devStore.lineGroup)
    // // this.index = this.$store.state.devStore.lineGroup.size
    // this.lineList = this.$store.state.devStore.lineItem
    // console.log(this.lineList)
  },
  created() {
    eventbus.$on("menuSetted", () => {
      console.log("저장완료 요청 ");
      this.$router.push({
        name: "DevActInput",
        params: { appId: this.$route.params.appId },
      });
    });

    eventbus.$once("addListList", (res, count)=>{

      if(count == this.lineList.length){
        this.lineList.push(res)

      } else {
        this.lineList[count] = res
      }


      console.log(res, count)
      eventbus.$emit("GroupComponent")
    })

    console.log("여기 :",this.$store.state.devStore.apiSchema)
    console.log("여기 :",this.$store.state.devStore.lineGroup)

    //group 
    // this.groupLabel = this.$store.state.devStore.lineGroup.label 
    // this.groupKey = this.$store.state.devStore.lineGroup.key 

    
    if (this.$store.state.devStore.apiSchema != null) {
      this.groupList.key = this.$store.state.devStore.apiSchema.keys.replace(
        /"/gi,
        ""
      );
      this.groupList.label = this.$store.state.devStore.apiSchema.label.replace(
        /"/gi,
        ""
      );
      console.log(
        "what about me?",
        this.$store.state.devStore.apiSchema.label.replace(/"/gi, ""),
        this.groupList
      );

      this.$store.state.devStore.lineGroup = {keys : this.groupList.key, label :  this.groupList.label}
      // this.$store.state.devStore.lineGroup.label = this.groupList.label;

      console.log("체크: ", this.$store.state.devStore.lineGroup);

      // this.listlist = JSON.parse(this.$store.state.devStore.apiSchema.form);



    //아이템 
    if(JSON.parse(this.$store.state.devStore.apiSchema.form)){
      console.log(JSON.parse(this.$store.state.devStore.apiSchema.form))

      this.$store.state.devStore.lineItem = JSON.parse(this.$store.state.devStore.apiSchema.form)

      this.lineList = JSON.parse(this.$store.state.devStore.apiSchema.form)



    console.log(this.$store.state.devStore.lineItem)

    }




















    }




    // this.indexer = this.$store.state.devStore.reMenu

    // console.log("created line geoup item ");
    // console.log(this.typeData);
    // console.log(this.$store.state.devStore.apiSchema);
    // console.log(this.$store.state.devStore.lineItem);

    // this.index = this.$store.state.devStore.reMenu;

    // console.log("ㄱㄹ:", this.$store.state.devStore.lineGroup.keys);
    // if (this.$store.state.devStore.lineGroup.keys != "") {
    //   this.groupKey = this.$store.state.devStore.lineGroup.keys;
    //   this.oldText = this.$store.state.devStore.lineGroup.keys;
    // }
    // if (this.$store.state.devStore.lineGroup.label != "") {
    //   this.groupLabel = this.$store.state.devStore.lineGroup.label;
    // }

    // if (this.$store.state.devStore.apiSchema != null) {
    //   console.log("아이템 아이템 테스트 :", JSON.parse(this.$store.state.devStore.apiSchema.form).length, this.$store.state.devStore.lineItem.length)
    //   if (
    //     JSON.parse(this.$store.state.devStore.apiSchema.form).length >
    //     this.$store.state.devStore.lineItem.length
    //   ) {
    //     this.$store.state.devStore.lineItem = JSON.parse(
    //       this.$store.state.devStore.apiSchema.form
    //     );
    //   }
    // }

    // console.log("아이템 아이템 테스트 :",  this.$store.state.devStore.lineItem)

    // this.lineList = new Array();
    // if (this.$store.state.devStore.lineItem.length > 0) {
    //   this.listCount = this.$store.state.devStore.lineItem.length;

    //   for (var i = 0; i < this.listCount; i++) {


    //     this.lineList.push(this.$store.state.devStore.lineItem[i]);
    //   }

    //   this.$store.state.devStore.lineItem = this.lineList;

    //   console.log(this.$store.state.devStore.lineItem);
    //   console.log(this.listCount);


    //   console.log(this.lineList);

    //   console.log("ㄷㄷㄷ");
    // }
    //  else {
    //   // this.groupKey = ""
    //   // this.groupLabel = ""

    //   this.listCount = 0;

    //   this.$store.state.devStore.lineItem = [];
    // }
 
  },
  beforeDestroy() {
    console.log("화면 이동 전");
    // eventbus.$off("toKeyValueComponent")
  },
};
</script>
